import { Link } from "react-router-dom";
import LogoImg from "../../assets/logo.png";
import useForm from "../../hooks/useForm";
import "./styles.scss";
import { useContext } from "react";
import { UserContext } from "../../context/UserContext";


export function Login() {
  const email = useForm();
  const password = useForm();

  const { userLogin, error, loading, ToastContainer } = useContext(UserContext);

  async function handleSubmit(event) {
    event.preventDefault();

    userLogin(email.value, password.value);
  }

  return (
    <div className="loginContainer fadeIn">
      <ToastContainer theme="dark" />
      <div className="logo">
        <img src={LogoImg} alt="Bizsys" />
      </div>

      <form onSubmit={handleSubmit}>
        <input
          type="email"
          className="form-control"
          name="email"
          id="email"
          placeholder="Email"
          {...email}
          required
        />
        <input
          type="password"
          name="password"
          id="password"
          placeholder="Senha"
          className="form-control"
          {...password}
          required
        />

        <Link to="#">Esqueceu a senha? Entre em contato:</Link>
        <Link
          to="#"
          onClick={(e) => {
            window.location = "mailto:hello@bizsys.com.br";
            e.preventDefault();
          }}
        >
          hello@bizsys.com.br
        </Link>
        {loading ? (
          <button type="submit" disabled>
            Entrando...
          </button>
        ) : (
          <button type="submit">Acessar</button>
        )}
      </form>
    </div>
  );
}
